// extracted by mini-css-extract-plugin
export default {"wrapper":"GeneralReview_wrapper__+dbUa","scoreCard":"GeneralReview_scoreCard__1jUvn","likeAnimation":"GeneralReview_likeAnimation__ctWfk"};